import { KeepExploringCarousel } from "@faire/deprecated-retailer-visitor-shared/components/KeepExploringCarousel";
import {
  CarouselContainer,
  Wrapper,
} from "@faire/deprecated-retailer-visitor-shared/views/brand/logged-out/components/common";
import React from "react";

interface IProps {
  topCategoryPath?: string;
}

export const CategoriesCarousel = ({
  ref,
  ...props
}: IProps & {
  ref?: React.Ref<HTMLDivElement>;
}) => (
  <Wrapper ref={ref}>
    <CarouselContainer>
      <KeepExploringCarousel
        dataTestId="logged-out-brand-keep-exploring"
        clickTrackPath="logged-out-brand/categories-carousel"
        highlightCategoryPath={props.topCategoryPath}
      />
    </CarouselContainer>
  </Wrapper>
);
